/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_SubtitleInputs */

const es_admin_billing_batch_subtitle = /** @type {(inputs: Admin_Billing_Batch_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagá varios meses de una vez y obtené un descuento sobre la tarifa base.`)
};

const en_admin_billing_batch_subtitle = /** @type {(inputs: Admin_Billing_Batch_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay several months at once and get a discount on the base rate.`)
};

/**
* | output |
* | --- |
* | "Pay several months at once and get a discount on the base rate." |
*
* @param {Admin_Billing_Batch_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_subtitle = /** @type {((inputs?: Admin_Billing_Batch_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_subtitle(inputs)
	return en_admin_billing_batch_subtitle(inputs)
});
export { admin_billing_batch_subtitle as "admin.billing.batch.subtitle" }